export enum ApplicationConfigurationKeyEnum {
  apiUrl = 'VITE_API_URL',
  apiUrlDev = 'VITE_API_URL_DEV',
  authDomain = 'VITE_AUTH_DOMAIN',
  authClientId = 'VITE_AUTH_CLIENT_ID',
  ciamApiUrl = 'CIAM_API_URL',
  ciamGatewayUrl = 'CIAM_GATEWAY_URL_DEV',
  sensitiveInformationObfuscationSymbol = 'SENSITIVE_INFORMATION_OBFUSCATION_SYMBOL',
  sensitiveInformationObfuscationLength = 'SENSITIVE_INFORMATION_OBFUSCATION_LENGTH',
  heapId = 'VITE_HEAP_ID',
  helpUrl = 'HELP_URL',
  aiAssistantUrl = 'AI_ASSISTANT_URL',
  env = 'ENV',
  rumAuth = 'RUM_AUTH',
  githubOwner = 'VITE_GITHUB_OWNER',
  termsAndConditionsResource = 'TERMS_AND_CONDITION_RESOURCE_URL',
  ticketIncidentsServiceLevelPriorityDocs = 'TICKET_INCIDENTS_SERVICE_LEVEL_PRIORITY_DOCS',
  contactUs = 'CONTACT_US',
  swoSupport = 'SWO_SUPPORT',
  noEmailKnowledgeArticle = 'NO_EMAIL_KNOWLEDGE_ARTICLE',
  ssoHelpKnowledgeArticle = 'SSO_HELP_KNOWLEDGE_ARTICLE',
  urlMigrationArticle = 'URL_MIGRATION_ARTICLE',
  userSettings = 'USER_SETTINGS_URL',
  profileSettings = 'PROFILE_SETTINGS_URL',
  globalLogoutUrl = 'GLOBAL_LOGOUT_URL',
  notificationApiKey = 'NOTIFICATION_API_KEY',
  gtmId = 'GTM_ID',
  flagKey = 'FLAG_KEY',
  flagUrl = 'FLAG_URL',
  flagEnv = 'FLAG_ENV',
  publisherUpdatesSupportEmail = 'VITE_PUBLISHER_UPDATES_SUPPORT_EMAIL',
  casesKnowledgeBaseUrl = 'VITE_CASES_KNOWLEDGE_BASE_URL',
}
